import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import FilterPagination from 'pages/parts/FilterPagination'
import { httpOk, GET } from 'helpers/api'
import { formatMoney, formatDate, returnSign } from 'helpers/helpers'

function RollWarehouse() {
	const { t } = useTranslation()

	const [data, setData] = useState({ data: [] })
	const [filter, setFilter] = useState('all')   // all | low | dead | debt
	const [search, setSearch] = useState('')

	// Rulon ustiga bosilganda ochiladigan tarix oynasi (harakatlar)
	const [showModal, setShowModal] = useState({ show: false, data: {}, item: null })
	const [historyPagination, setHistoryPagination] = useState({ url: `/report-balance-history`, response: null })

	async function load() {
		const res = await GET('/report/roll-warehouse', {}, { loader: true })
		if (httpOk(res)) setData(res.data)
	}
	useEffect(() => { load() }, []) // eslint-disable-line react-hooks/exhaustive-deps

	async function getBalanceHistory(item) {
		let url = `/report-balance-history`
		let p = ""
		if (item.element_id) p += returnSign(p) + 'product_id=' + item.element_id
		if (historyPagination.page) p += returnSign(p) + 'page=' + historyPagination.page
		if (historyPagination.size) p += returnSign(p) + 'size=' + historyPagination.size
		const res = await GET(url + p, {}, { loader: true })
		if (httpOk(res)) {
			setShowModal({ show: true, data: res.data, item })
			setHistoryPagination({ ...historyPagination, url: url + p, response: res.data })
		}
	}
	async function toggleModal(bool, item) {
		if (bool) {
			setHistoryPagination({ url: `/report-balance-history`, response: null, page: '', size: '' })
			await getBalanceHistory(item)
		} else {
			setShowModal({ show: false, data: {}, item: null })
			setHistoryPagination({ url: `/report-balance-history`, response: null, page: '', size: '' })
		}
	}
	async function paginateHistory(page, size) {
		setHistoryPagination({ ...historyPagination, page, size })
	}
	useEffect(() => {
		if (showModal.show && showModal.item) getBalanceHistory(showModal.item)
	}, [historyPagination.page, historyPagination.size]) // eslint-disable-line react-hooks/exhaustive-deps

	function getMovementQuantityClass(item) {
		if (item.movement_name === t('return')) return 'text-warning'
		return item.movement_transaction_type === 'plus' ? 'text-success' : 'text-danger'
	}

	function daysClass(d) {
		if (d === null || d === undefined) return 'text-muted'
		if (d <= 7) return 'text-danger fw-bold'
		if (d <= 20) return 'text-warning fw-bold'
		return 'text-success'
	}
	function chip(r) {
		const base = { fontSize: '12px', padding: '2px 9px', borderRadius: '4px', fontWeight: 500, whiteSpace: 'nowrap' }
		if (r.signal === 'low') return <span style={{ ...base, background: '#fdecea', color: '#c0392b' }}>Buyurtma ber</span>
		if (r.signal === 'dead') return <span style={{ ...base, background: '#f1f3f5', color: '#868e96' }}>O'lik</span>
		if (r.signal === 'debt') return <span style={{ ...base, background: '#fdf6e3', color: '#b7950b' }}>Qarz</span>
		return <span style={{ color: '#adb5bd', fontSize: '12px' }}>Normal</span>
	}

	const rows = (data.data || []).filter(r => {
		if (filter !== 'all' && r.signal !== filter) return false
		if (search && !r.element_name.toLowerCase().includes(search.toLowerCase())) return false
		return true
	})
	const fTon = rows.reduce((s, r) => s + Number(r.qoldiq_t || 0), 0)
	const fMetr = rows.reduce((s, r) => s + Number(r.qoldiq_m || 0), 0)
	const fVal = rows.reduce((s, r) => s + Number(r.value || 0), 0)
	const fMiss = rows.reduce((s, r) => s + Number(r.pending_m || 0), 0)

	const Tile = ({ id, bg, color, label, val, sm }) => (
		<div className="col">
			<div className="rounded p-2 h-100"
				style={{ cursor: 'pointer', background: bg, border: filter === id ? `1px solid ${color}` : '1px solid transparent' }}
				onClick={() => setFilter(filter === id ? 'all' : id)}>
				<div className="small text-uppercase" style={{ color, opacity: 0.8 }}>{label}</div>
				<div className="fw-bold fs-5" style={{ color }}>{val}</div>
				<div className="text-muted small">{sm}</div>
			</div>
		</div>
	)

	return (
		<>
			<div className="page-header">
				<h4 className="vertical-center h-100">{t('warehouse_rolls')} [{data.count || 0}]</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="row g-2 mb-3">
						<Tile id="all" bg="#eef2ff" color="#4a5aa8" label="Umumiy qiymat"
							val={`${formatMoney(data.total_value)} $`} sm={`≈ ${formatMoney(data.total_value * 12100 / 1e6, 1)} mln so'm · ${data.count} rulon`} />
						<Tile id="low" bg="#fdecea" color="#c0392b" label="Kam qolgan" val={data.low_count} sm="buyurtma berish kerak" />
						<Tile id="dead" bg="#f1f3f5" color="#868e96" label="O'lik zaxira" val={data.dead_count} sm={`${formatMoney(data.dead_frozen)} $ muzlagan`} />
						<Tile id="debt" bg="#fdf6e3" color="#b7950b" label="Rulon qarzi" val={data.debt_count} sm={`${formatMoney(data.debt_missing, 1)} m kutilmoqda`} />
					</div>

					<div className="d-flex gap-2 align-items-center mb-3 flex-wrap">
						<input className="form-control" style={{ maxWidth: '240px' }} placeholder={t('search') + '...'}
							value={search} onChange={e => setSearch(e.target.value)} />
						<span className="text-muted small">Filtr:</span>
						{[['all', 'Hammasi'], ['low', '🔴 Kam qolgan'], ['dead', "⚫ O'lik"], ['debt', '🟡 Qarz']].map(([k, lbl]) => (
							<button key={k} className={`btn btn-sm ${filter === k ? 'btn-primary' : 'btn-outline-secondary'}`}
								onClick={() => setFilter(k)}>{lbl}</button>
						))}
					</div>

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ width: '33px' }} className="text-center">#</th>
									<th>{t('roll')}</th>
									<th className="text-end">{t('tonna')}</th>
									<th className="text-end">{t('metr')}</th>
									<th className="text-end">Qiymat $</th>
									<th className="text-end">Necha kun yetadi</th>
									<th className="text-end">Oxirgi sotuv</th>
									<th className="text-end">Qarz</th>
									<th>Tavsiya</th>
								</tr>
							</thead>
							<tbody>
								{rows.length === 0 &&
									<tr><td colSpan={9} className="text-center text-muted py-4">{t('list_empty')}</td></tr>
								}
								{rows.map((r, i) => (
									<tr className="tr-middle" key={r.element_id}>
										<td className="text-center">{i + 1}</td>
										<td className="text-primary cursor" style={{ cursor: 'pointer' }} onClick={() => toggleModal(true, r)}>
											{r.element_name}
										</td>
										<td className="text-end">{formatMoney(r.qoldiq_t, 2)}</td>
										<td className="text-end">{formatMoney(r.qoldiq_m, 1)}</td>
										<td className="text-end">{formatMoney(r.value)}</td>
										<td className={`text-end ${daysClass(r.days)}`}>
											{r.days !== null ? `${r.days} kun` : '—'}
										</td>
										<td className={`text-end ${r.last_sale_days !== null && r.last_sale_days >= 60 ? 'text-secondary' : ''}`}>
											{r.last_sale_days !== null ? `${r.last_sale_days} kun oldin` : '—'}
										</td>
										<td className="text-end">
											{r.pending_m > 0 ? <span className="text-warning fw-bold">{formatMoney(r.pending_m, 1)} m</span> : '—'}
										</td>
										<td>{chip(r)}</td>
									</tr>
								))}
							</tbody>
							<tfoot>
								<tr>
									<td></td>
									<td><b>{t('total')} ({rows.length})</b></td>
									<td className="text-end"><b>{formatMoney(fTon, 2)}</b></td>
									<td className="text-end"><b>{formatMoney(fMetr, 1)}</b></td>
									<td className="text-end"><b>{formatMoney(fVal)} $</b></td>
									<td></td><td></td>
									<td className="text-end"><b>{fMiss > 0 ? formatMoney(fMiss, 1) + ' m' : '—'}</b></td>
									<td></td>
								</tr>
							</tfoot>
						</table>
					</div>

					<div className="text-muted mt-2 small">
						<b>Necha kun yetadi</b> = qoldiq ÷ kunlik o'rtacha sarf (≤7 kun qizil — buyurtma bering). ·
						<b>Oxirgi sotuv</b> 60+ kun → o'lik zaxira. ·
						<b>Qarz</b> — kutilayotgan buyurtma. ·
						<b>Buyurtma</b> = ~30 kunlik zaxira tavsiyasi. ·
						Rulon nomini bosing → harakatlar tarixi.
					</div>
				</div>
			</div>

			{/* Rulon harakatlari tarixi (rulon nomini bosganda) */}
			<Modal show={showModal.show} animation={false} centered dialogClassName="update-modal-width" onHide={() => toggleModal(false)} size="xl">
				<Modal.Header closeButton>
					<Modal.Title>{t('balance2')} [{showModal.data.total}]</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: '33px' }} className="text-center">#</th>
									<th style={{ width: '20%' }}>{t('product_name')}</th>
									<th style={{ width: '10%' }}>{t('id')}</th>
									<th style={{ width: '10%' }}>{t('type')}</th>
									<th style={{ width: '10%' }}>{t('warehouse')}</th>
									<th style={{ width: '10%' }}>{t('movement')}</th>
									<th style={{ minWidth: '70px' }} className="text-end">{t('quantity')}</th>
									<th style={{ minWidth: '70px' }} className="text-end">{t('balance2')}</th>
									<th style={{ minWidth: '80px' }} className="text-end">{t('price')}</th>
									<th style={{ minWidth: '100px' }} className="text-end">{t('amount')}</th>
									<th style={{ minWidth: '120px' }} className="text-center">{t('date')}</th>
								</tr>
							</thead>
							<tbody>
								{showModal?.data?.data?.map((item, index) => (
									<tr className="tr-middle" key={index}>
										<td className="text-center">{item.row_number}</td>
										<td>{item.product_name}</td>
										<td>{item.element_id}</td>
										<td>{item.product_type_name}</td>
										<td>{item.wms_name}</td>
										<td>{item.movement_name}</td>
										<td className={`text-end ${getMovementQuantityClass(item)}`}>{formatMoney(item.quantity, 2)}</td>
										<td className="text-end">{formatMoney(item.balance, 2)}</td>
										<td className="text-end">{formatMoney(item.cost_price)}</td>
										<td className="text-end">{formatMoney(item.total_amount)}</td>
										<td className="text-center">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
					{historyPagination.response &&
						<FilterPagination pagination={historyPagination} paginate={paginateHistory}></FilterPagination>
					}
				</Modal.Body>
			</Modal>
		</>
	)
}

export default RollWarehouse
